<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <a class="navbar-brand" href="#">KRBS CIRCULARS</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item active mr-2">
          <a class="nav-link" style="font-size:14px;" href="#"><font-awesome-icon icon="house" class="ml-2 mr-1" /> Home <span class="sr-only">(current)</span></a>
        </li>

        <li class="nav-item mr-2">
          <a class="nav-link" style="font-size:14px;" href="#"> <font-awesome-icon icon="sticky-note" class="ml-2 mr-1" /> Memo Viewed</a>
        </li>

        <li class="nav-item mr-2">

          <a class="nav-link" style="font-size:14px;" href="#">  <font-awesome-icon icon="video" class="ml-2 mr-1" /> Training Videos</a>
        </li>

        <li class="nav-item mr-2">
          <a class="nav-link" style="font-size:14px;" href="#"> <font-awesome-icon icon="display" class="ml-2 mr-1" /> TTOS Presentations</a>
        </li>
      </ul>

      <!--      <form class="form-inline my-2 my-lg-0">-->
      <!--        <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search">-->
      <!--        <button class="btn btn-outline-success my-2 my-sm-0" type="submit">Search</button>-->
      <!--      </form>-->




      <ul class="navbar-nav ml-auto ml-md-0">
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" id="userDropdown" href="#" role="button" data-toggle="dropdown"
             aria-haspopup="true" aria-expanded="false">
            <i class="fas fa-user fa-fw"></i>
            <font-awesome-icon icon="user-shield" class="ml-2 mr-1" />
            <span style="font-size:14px;">Administrator</span>
          </a>

          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown">
            <a class="dropdown-item" href="#">Upload Kobe Memo</a>
            <a class="dropdown-item" href="#">Upload ROHQ Memo</a>
            <a class="dropdown-item" href="#">Upload MAKUHARI Memo</a>
            <a class="dropdown-item" href="#">Upload SMS Memo</a>
            <a class="dropdown-item" href="#">Upload SMS Handbook</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item">Report #1</a>
            <a class="dropdown-item" href="/crew-search">Report #2</a>
            <router-link :to="{name : 'CrewSearch'}" class="nav-link border-0 text-uppercase font-weight-bold"
                         href="#" :class="{ 'active': 'CrewSearch'}">
              Report #2
            </router-link>
            <a class="dropdown-item">Report #3</a>
          </div>
        </li>
      </ul>


      <ul class="navbar-nav ml-auto ml-md-0">
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" id="userDropdown" href="#" role="button" data-toggle="dropdown"
             aria-haspopup="true" aria-expanded="false">
            <font-awesome-icon icon="gear" class="ml-2 mr-1" />
            <span style="font-size:14px;">Account</span>
          </a>

          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown">
            <a class="dropdown-item" href="#">Change Password</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item">Logout</a>
          </div>
        </li>
      </ul>


    </div>
  </nav>
</template>

<script>
export default {
  name: 'BaseAppTopNav',
};
</script>

<style scoped>

</style>
